import React from 'react';
import {DATE_TIME_FORMAT, getFormattedDate, isDefaultDate} from "../../../utils/convertTime.js";
import classnames from "classnames";
import {DELIVERY_STRATEGY} from "../../../utils/enums.js";
import './style.scss';
import IconButton from "../IconButton/index.js";

const TargetTimeTable = ({order}) => {
    const isConceteTime = order.DeliveryStrategy === DELIVERY_STRATEGY.concreteTime;
    const windowStart = isDefaultDate(order.TargetTimeWindowStart) ? null : order.TargetTimeWindowStart;
    const target = isDefaultDate(order.TargetTime) ? null : order.TargetTime;

    return (
        <div className={classnames('targetTimeTable', {colored: isConceteTime})}>
            {getFormattedDate(windowStart, DATE_TIME_FORMAT)}
            {windowStart && " - "}
            {getFormattedDate(target, DATE_TIME_FORMAT)}

            {isConceteTime && (
                <IconButton iconName={'time'} isIcon/>
            )}
        </div>
    )
}

export default TargetTimeTable;